export default __webpack_public_path__ + "static/media/icon-certificado.7f421ec8.png";